import React from 'react'
import { useNavigate } from 'react-router-dom'
import WorldGuidedCreation from '../components/WorldGuidedCreation'

export const WorldCreator = () => {
  const navigate = useNavigate()

  const handleComplete = () => {
    navigate('/world-simulator')
  }

  return <WorldGuidedCreation onComplete={handleComplete} />
}
